import React from 'react';
import CommonProductSelection from 'src/constrains/AdvancedFilters/Components/CommonStoreProductsWithTable';

const ProductsInShoppingCart = (props) => {
  const {
    noStyle,
    radioName,
    listName,
    id,
    onClear, //onReselect, onClear
    disabled,
  } = props;
  return (
    <CommonProductSelection
      noStyle={noStyle}
      radioName={radioName}
      listName={listName}
      id={id}
      //   onReselect={onReselect}
      onClear={onClear}
      disabled={disabled}
    />
  );
};
export default ProductsInShoppingCart;
